// extracted by mini-css-extract-plugin
module.exports = {"CsaMoreMenuWrapper":"CsaMoreMenu_CsaMoreMenuWrapper__1XZxs","cursor":"CsaMoreMenu_cursor__16mtH","menuMore":"CsaMoreMenu_menuMore__2irdW"};